import React from 'react';
import LMSHeader from '../components/LMSHeader';

const TermsAndConditionsPage = () => {
  return (
    <>
      <LMSHeader />
      <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm border border-neutral-200 dark:border-neutral-700 p-8">
            <h1 className="text-3xl font-bold text-neutral-900 dark:text-white mb-6">
              Terms and Conditions
            </h1>
            <p className="text-neutral-600 dark:text-neutral-400 mb-8">
              Last updated: {new Date("2025-06-02").toLocaleDateString()}
            </p>

            <div className="text-neutral-900 dark:text-neutral-400 max-w-none space-y-6">
              <section>
                <h2><strong>1. Introduction</strong></h2>
                <p>
                  Welcome to Boleum Energy & Technology Limited (“Boleum”, “we”, “our”, or “us”). These
                  Terms and Conditions (“Terms”) govern your access to and use of our global online learning
                  platform, including all courses, content, services, and features (collectively, the
                  “Services”). By accessing or using the Services, you agree to be bound by these Terms. If
                  you do not agree, please refrain from using the Services.
                </p>
              </section>

              <section>
                <h2><strong>2. Account Registration</strong></h2>
                <p>
                  To access certain features of the platform, you must create an account. You agree to:
                </p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Provide accurate, current, and complete registration information</li>
                  <li>Maintain and promptly update your account details</li>
                  <li>Keep your password secure and confidential</li>
                  <li>Accept full responsibility for all activities conducted under your account</li>
                </ul>
              </section>

              <section>
                <h2><strong>3. Course Enrollment and Payment</strong></h2>
                <p>
                  <strong>3.1 Course Fees:</strong>
                </p>
                <p>Course fees are displayed in local currency based on your region. Prices are subject to
                  change without prior notice. </p>
                <p>
                  <strong>3.2 Payment Processing:</strong>
                </p>
                <p>We partner with secure global payment processors (e.g., Stripe, PayPal, PayStack) to
                  facilitate transactions. All payments are final unless otherwise stated in our refund policy or
                  required by applicable law. </p>
                <p>
                  <strong>3.3 Free Courses:</strong>
                </p>
                <p>Courses offered for free may be transitioned to paid offerings with a minimum of 30 days’
                  notice. </p>
              </section>

              <section>
                <h2><strong>4. Intellectual Property</strong></h2>
                <p>
                  <strong>4.1 Platform Content:</strong>
                </p>
                <p>All course materials, including videos, quizzes, assignments, and other content, are either
                  owned by Boleum or licensed by third-party instructors. You may not copy, distribute,
                  modify, or create derivative works without explicit written permission. </p>
                <p>
                  <strong>4.2 User-Generated Content :</strong>
                </p>
                <p>You retain ownership of any content you submit (e.g., assignments, feedback), but grant
                  Boleum a non-exclusive, worldwide license to use, reproduce, and display such content for
                  operational and educational purposes. </p>
              </section>

              <section>
                <h2><strong>5. User Responsibilities</strong></h2>
                <p>You agree not to:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Use the platform for unlawful or unauthorized purposes</li>
                  <li>Upload viruses, malware, or disruptive content</li>
                  <li>Share your account credentials with others</li>
                  <li>Use automated tools to scrape or extract platform data</li>
                </ul>
              </section>

              <section>
                <h2><strong>6. Refund Policy</strong></h2>
                <p>
                  <strong>6.1 Paid Courses:</strong>
                </p>
                <p>You may request a full refund within 14 days of purchase, provided you have accessed less
                  than 20% of the course content. </p>
                <p>
                  <strong>6.2 No Refunds:</strong>
                </p>
                <p>Refunds will not be issued after 14 days or if more than 20% of the course has been
                  consumed, except where required by law.</p>
              </section>

              <section>
                <h2><strong>7. Limitation of Liability</strong></h2>
                <p>
                  The Services are provided “as is” without warranties of any kind. Boleum does not
                  guarantee:
                </p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Continuous, error-free access</li>
                  <li>Accuracy or completeness of content</li>
                  <li>That the Services will meet your expectations or learning goals</li>
                </ul>
                <p>To the maximum extent permitted by law, Boleum shall not be liable for any indirect,
                  incidental, or consequential damages.
                </p>
              </section>

              <section>
                <h2><strong>8. Termination</strong></h2>
                <p>
                  We reserve the right to suspend or terminate your account for:
                </p>
                <ul className="list-disc pl-6 space-y-1 ">
                  <li>Breach of these Terms</li>
                  <li>Fraudulent or abusive behavior</li>
                  <li>Non-payment or chargeback disputes</li>
                </ul>
                <p>You may terminate your account at any time by contacting our support team.</p>
              </section>

              <section>
                <h2><strong>9. Governing Law</strong></h2>
                <p>
                  These Terms shall be governed by and construed in accordance with the laws of the
                  jurisdiction in which Boleum is headquartered, unless otherwise required by local law.
                  Disputes shall be resolved in the courts of competent jurisdiction.
                </p>
              </section>

              <section>
                <h2><strong>10. Changes to Terms</strong></h2>
                <p>
                  We may update these Terms periodically. Continued use of the Services after changes are
                  posted constitutes acceptance. Material changes will be communicated via email or
                  platform notifications.
                </p>
              </section>

              <section>
                <h2><strong>11. Contact Us</strong></h2>
                <p>
                  For questions or support, please reach out to us:
                </p>
                <p>
                  <strong>Email:</strong> training@boleum.com<br />
                  <strong>Address:</strong> #1 Beside Christ Missionaries Crusaders Church, Opp NNPC Housing Estate Ekpan, Delta State, Nigeria
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditionsPage;